export default __webpack_public_path__ + "static/media/airplane.d5c5f4a3.png";